import React, { PureComponent } from 'react'
import { AccountGuidError, AuthError } from '@signal/utils/errors'
import renderIf from '@signal/utils/renderIf'
import ContextFetcher from '../contextFetch/Fetcher'
import useMenuService from './index'
import MenuServiceContext from './Context'
import isValidGuid from '@signal/utils/isValidGuid'

class MenuServiceLoader extends PureComponent {
  state = { message: '', sawAuthError: false }

  static getDerivedStateFromError(error) {
    const { message: errorMessage } = error
    return { hasError: true, message: errorMessage }
  }

  componentDidCatch(error) {
    if (error instanceof AuthError) {
      this.setState({
        sawAuthError: true
      })
      return
    }
    throw error
  }

  render() {
    const { accountId, children, ...hookParams } = this.props
    const { sawAuthError } = this.state

    if (accountId && !isValidGuid(accountId)) {
      throw new AccountGuidError()
    }
    return renderIf(
      !sawAuthError,
      () => (
        <ContextFetcher
          accountId={accountId}
          fetchHook={useMenuService}
          FetchContext={MenuServiceContext}
          {...hookParams}
        >
          {children}
        </ContextFetcher>
      ),
      () => children
    )
  }
}

export default MenuServiceLoader
